
export class dbhValidatorSettings {
    language;
    validationGroup;
    useTooltip;
    useDefaultErrorClass;
    useDefaultStyleSheet;
    useAutoTrimOnBlur;
    checkOnBlur;
    useTextfieldReduction;
    customErrorClass;
    customStyleSheet;
    regexIsMail;
    regexIsNumber;

    constructor() {
    }
}

export class dbh_validation {
    options: dbhValidatorSettings;
    errorList = [];

    DbhMessageRequiredFieldMissing = "{0} ist ein Pflichtfeld!";
    DbhMessageEMailFieldIncorrect = "{0} ist keine gültige E-Mail-Adresse!";
    DbhMessageNumberFieldIncorrect = "{0} ist keine gültige Zahl!";
    DbhMessageFieldIncorrectNeutral = "Die Eingabe für {0} ist ungültig!";
    DbhMessageMaxLength = "Für {0} dürfen nur {1} Zeichen eingegeben werden!";
    CustomMessage = "AAA {0} BBB!";

    constructor(_options: dbhValidatorSettings) {
        var context = this;
        this.options = _options;
        if (this.options != null && this.options != undefined && !(this.options instanceof dbhValidatorSettings)) {
            console.log("Options for dbhValidator are not defined as dbhValidatorSettings!");
            return;
        }

        if (!this.dbhCheckValueSet(this.options)) {
            this.options = new dbhValidatorSettings();
        }

        if (!this.dbhCheckValueSet(this.options.language)) this.options.language = "DE";
        if (!this.dbhCheckValueSet(this.options.validationGroup)) this.options.validationGroup = "";
        if (!this.dbhCheckValueSet(this.options.useTooltip)) this.options.useTooltip = true;
        if (!this.dbhCheckValueSet(this.options.useDefaultErrorClass)) this.options.useDefaultErrorClass = true;
        if (!this.dbhCheckValueSet(this.options.useDefaultStyleSheet)) this.options.useDefaultStyleSheet = true;
        if (!this.dbhCheckValueSet(this.options.useAutoTrimOnBlur)) this.options.useAutoTrimOnBlur = true;
        if (!this.dbhCheckValueSet(this.options.checkOnBlur)) this.options.checkOnBlur = true;
        if (!this.dbhCheckValueSet(this.options.useTextfieldReduction)) this.options.useTextfieldReduction = true;
        if (!this.dbhCheckValueSet(this.options.customErrorClass)) this.options.customErrorClass = "";
        if (!this.dbhCheckValueSet(this.options.customStyleSheet)) this.options.customStyleSheet = "";
        if (!this.dbhCheckValueSet(this.options.regexIsMail)) this.options.regexIsMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.dbhCheckValueSet(this.options.regexIsNumber)) this.options.regexIsNumber = /^\d+$/;

        // Load file with messages of choosen language
        //$.ajax({
        //    dataType: "script",
        //    cache: true,
        //    url: '/Scripts/ClientValidation/Messages/' + options.language + '.js'
        //});

        //if (this.options.useDefaultStyleSheet) {
        //    $('<link/>', {
        //        rel: 'stylesheet',
        //        type: 'text/css',
        //        href: '/Scripts/ClientValidation/dbh_validation.min.css'
        //    }).appendTo('head');
        //}

        //if (this.dbhCheckValueSet(this.options.customStyleSheet)) {
        //    $('<link/>', {
        //        rel: 'stylesheet',
        //        type: 'text/css',
        //        href: options.customStyleSheet
        //    }).appendTo('head');
        //}

        if (this.options.checkOnBlur) {
            $('*[dbh-validation]').each(function (index, elem) {
                $(elem).on('blur', function () {
                    if (context.options.useAutoTrimOnBlur && context.dbhCheckValueSet($(elem).attr('type')) && $(elem).attr('type') == "text") {
                        $(elem).text($(elem).text().trim());
                        $(elem).val($(elem).val().toString().trim());
                        $(elem).html($(elem).html().trim());
                    }
                    context.validate();
                });
            });
        }
    }

    dbhCheckValueSet = (value: any): boolean => {
        return value != undefined && (value != "" || value == "0") && value != null;
    }

    guid = (): any => {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    public dbhGetReferenceValue = (elem): any => {
        if (this.dbhCheckValueSet($(elem).attr('name'))) {
            return $(elem).attr('name').split('$').join('_');
        }
        else if (this.dbhCheckValueSet($(elem).attr('id'))) {
            return $(elem).attr('id').split('$').join('_');
        }
        // in case of unset id attribute the script autofill this value
        else {
            $(elem).attr('id', this.guid());
            return $(elem).attr('id');
        }
    }

    public validateInternal = (elem: any, errorList): any => {
        var context = this;
        var setOfControlsToValidate = null;

        this.clearValidationOutput(elem);

        if (this.dbhCheckValueSet(elem)) {
            setOfControlsToValidate = $(elem);
        }
        else {
            if (this.dbhCheckValueSet(this.options.validationGroup)) {
                setOfControlsToValidate = $('*[dbh-validation][dbh-validationGroup=' + this.options.validationGroup + ']:visible');
            }
            else {
                setOfControlsToValidate = $('*[dbh-validation]:visible');
            }
        }

        var validationResult = true;
        var interanlErrorList = [];

        $(setOfControlsToValidate).each(function (index, elem) {
            var interalValidatinResult = true;
            var dataField = context.dbhCheckValueSet($(elem).attr('dbh-validationDataField')) ? $(elem).attr('dbh-validationDataField') : "";

            // Check required
            if ($(elem).attr('dbh-validation').indexOf('required') > -1) {
                if (context.dbhCheckValueSet($(elem).attr('type'))) {
                    switch ($(elem).attr('type')) {
                        case "text":
                        case "date":
                            if (!context.dbhCheckValueSet($(elem).val()) && !context.dbhCheckValueSet($(elem).text())) {
                                interalValidatinResult = false;
                            }
                            break;
                        case "checkbox":
                            if (!$(elem).is(':checked')) {
                                interalValidatinResult = false;
                            }
                            break;
                        case "radio":
                            if (!$("input[name='" + $(elem).attr('name') + "']:checked").val()) {
                                interalValidatinResult = false;
                            }
                            break;
                        default:
                            throw "input type unknown for field reference '" + context.dbhGetReferenceValue($(elem)) + "'";
                            return;
                    }
                }
                else if ($(elem).is('textarea')) {
                    if (!context.dbhCheckValueSet($(elem).val())) {
                        interalValidatinResult = false;
                    }
                }
                else if ($(elem).hasClass('RadPicker')) {
                    if (!context.dbhCheckValueSet($(elem).find('.riTextBox').first().val())) {
                        interalValidatinResult = false;
                    }
                }
                else if ($(elem).is('select')) {
                    var selected_option = $(elem).find('option:selected');

                    if (!context.dbhCheckValueSet(selected_option) || !context.dbhCheckValueSet($(selected_option).val())) {
                        interalValidatinResult = false;
                    }
                }
                else if ($(elem).hasClass('RadEditor')) {
                    var radEditorOptions = {
                        trimText: true, // Removes all leading and trailing white-space characters. 
                        removeMultipleSpaces: true //Merges all white-space characters. 
                    }
                    var editor = $($(elem).attr('id'));
                    var oSelElem = this.editor.get_text(radEditorOptions); //get the editor content as plain text

                    if (!context.dbhCheckValueSet(oSelElem)) {
                        interalValidatinResult = false;
                    }
                }
                else {
                    throw "unknown element for field reference '" + context.dbhGetReferenceValue($(elem)) + "'";
                    return;
                }

                if (!interalValidatinResult && context.options.useTooltip) {
                    if (context.dbhCheckValueSet($(elem).attr('dbh-validationRequiredTooltipText'))) {
                        context.dbhAddTooltip(elem, $(elem).attr('dbh-validationRequiredTooltipText').toString().replace('{0}', dataField));
                    }
                    else {
                        context.dbhAddTooltip(elem, context.DbhMessageRequiredFieldMissing.toString().replace('{0}', dataField));
                    }
                }
                interanlErrorList.push(context.DbhMessageRequiredFieldMissing.toString().replace('{0}', dataField));
            }

            // MaxLength
            var regexML = /maxLength\(\d+\)/;
            var a = $(elem).attr('dbh-validation');
            if (regexML.test(a) && interalValidatinResult) {
                // Only for text-input
                if (context.dbhCheckValueSet($(elem).attr('type')) && $(elem).attr('type') == "text") {
                    var m = this.regexML.exec($(elem).attr('dbh-validation'))[0].replace("maxLength(", "").replace(")", "") * 1;
                    if ($(elem).text().toString().length > m || $(elem).val().toString().length > m) {
                        if (context.options.useTooltip) {
                            context.dbhAddTooltip(elem, context.DbhMessageMaxLength.replace('{0}', dataField).replace('{1}', this.m));
                        }
                        interanlErrorList.push(context.DbhMessageMaxLength.replace('{0}', dataField).replace('{1}', this.m));
                        interalValidatinResult = false;
                    }
                }
            }

            // Check mail
            if ($(elem).attr('dbh-validation').indexOf('mail') > -1 && interalValidatinResult) {
                if (context.dbhCheckValueSet($(elem).val()) && !context.isMail($(elem).val()) && !context.isMail($(elem).text())) {
                    if (context.options.useTooltip) {
                        context.dbhAddTooltip(elem, context.DbhMessageEMailFieldIncorrect.toString().replace('{0}', dataField));
                    }
                    interanlErrorList.push(context.DbhMessageEMailFieldIncorrect.toString().replace('{0}', dataField));

                    interalValidatinResult = false;
                }
            }

            // Check number
            if ($(elem).attr('dbh-validation').indexOf('number') > -1 && interalValidatinResult) {
                if (context.dbhCheckValueSet($(elem).val()) && !context.isNumber($(elem).val()) && !context.isNumber($(elem).text())) {
                    if (context.options.useTooltip) {
                        context.dbhAddTooltip(elem, context.DbhMessageNumberFieldIncorrect.toString().replace('{0}', dataField));
                    }
                    interanlErrorList.push(context.DbhMessageNumberFieldIncorrect.toString().replace('{0}', dataField));

                    interalValidatinResult = false;
                }
            }

            // Custom validation
            if (context.dbhCheckValueSet($(elem).attr('dbh-validationFunction'))) {
                if (!eval($(elem).attr('dbh-validationFunction'))) {

                    if (context.dbhCheckValueSet($(elem).attr('dbh-validationFunctionTooltipMessageParameter'))) {
                        context.dbhAddTooltip(elem, eval($(elem).attr('dbh-validationFunctionTooltipMessageParameter')).toString().replace('{0}', dataField));
                    }
                    else if (context.dbhCheckValueSet($(elem).attr('dbh-validationFunctionTooltipText'))) {
                        context.dbhAddTooltip(elem, $(elem).attr('dbh-validationFunctionTooltipText').toString().replace('{0}', dataField));
                    }
                    else if (context.options.useTooltip) {
                        context.dbhAddTooltip(elem, context.DbhMessageFieldIncorrectNeutral.toString().replace('{0}', dataField));
                    }
                    interanlErrorList.push(context.DbhMessageFieldIncorrectNeutral.toString().replace('{0}', dataField));

                    interalValidatinResult = false;
                }
            }

            if (!interalValidatinResult) {
                if (context.options.useDefaultErrorClass) {
                    /*if ($(elem).is('select')) {
                        elem = $(elem).parent();
                    }
                    else*/ if ($(elem).hasClass('riTextBox')) {
                        elem = $(elem).find('.RadInput');
                    }
                    $(elem).addClass('dbh_vaildationError');
                    if ($(elem).attr('type') == 'text' && context.options.useTextfieldReduction) {
                        $(elem).width(($(elem).width() - 25) + 'px');
                    }
                }
                if (context.dbhCheckValueSet(context.options.customErrorClass)) {
                    $(elem).addClass(context.options.customErrorClass);
                }
                validationResult = false;
            }
        });

        if (this.dbhCheckValueSet(errorList)) {
            errorList.push(interanlErrorList);
        }

        return validationResult;
    }

    public clearValidationOutput = (elem) => {
        var context = this;
        this.errorList = [];

        // Check only one element
        if (this.dbhCheckValueSet(elem)) {
            if (this.options.useDefaultErrorClass) {
                /*if ($(elem).is('select')) {
                    elem = $(elem).parent();
                }
                else*/ if ($(elem).hasClass('riTextBox')) {
                    elem = $(elem).find('.RadInput');
                }

                if ($(elem).hasClass('dbh_vaildationError')) {
                    $(elem).removeClass('dbh_vaildationError');
                    if ($(elem).attr('type') == 'text' && this.options.useTextfieldReduction) {
                        $(elem).width(($(elem).width() + 25) + 'px');
                    }
                }
            }
            if (this.dbhCheckValueSet(this.options.customErrorClass)) {
                $(elem).removeClass(this.options.customErrorClass);
            }

            $('.dbh_tooltipErr[dbh-validationReference=' + this.dbhGetReferenceValue.call(elem) + ']').remove();
        }
        // Check all
        else {
            var setOfControlsToValidate = null;
            if (this.dbhCheckValueSet(this.options.validationGroup)) {
                setOfControlsToValidate = $('*[dbh-validation][dbh-validationGroup=' + this.options.validationGroup + ']:visible');
            }
            else {
                setOfControlsToValidate = $('*[dbh-validation]:visible');
            }

            if (this.options.useDefaultErrorClass) {
                $(setOfControlsToValidate).each(function (index, element) {
                    /*if ($(elem).is('select')) {
                        elem = $(elem).parent();
                    }
                    else*/ if ($(elem).hasClass('riTextBox')) {
                        elem = $(elem).find('.RadInput');
                    }

                    if ($(element).hasClass('dbh_vaildationError')) {
                        $(element).removeClass('dbh_vaildationError');
                        if ($(element).attr('type') == 'text' && context.options.useTextfieldReduction) {
                            $(element).width(($(element).width() + 25) + 'px');
                        }
                    }
                });
            }
            if (this.dbhCheckValueSet(this.options.customErrorClass)) {
                $(setOfControlsToValidate).removeClass(this.options.customErrorClass);
            }
            $(setOfControlsToValidate).each(function (index, element) {
                $('.dbh_tooltipErr[dbh-validationReference=' + context.dbhGetReferenceValue.call(element) + ']').remove();
            });
        }
    }

    public dbhAddTooltip = (elem, text) => {
        var tooltip = $('<div />').addClass('dbh_tooltipErr');
        var dbh_tooltipEcke = $('<div />').addClass('dbh_tooltipEcke');
        var dbh_tooltipTxt = $('<span />').addClass('dbh_tooltipTxt').text(text);
        tooltip.append(dbh_tooltipEcke);
        tooltip.append(dbh_tooltipTxt);

        $(tooltip).attr('dbh-validationReference', this.dbhGetReferenceValue(elem));
        $(tooltip).insertAfter(elem);

        $(tooltip).css('top', ($(elem).position().top + ($(elem).height() * 0.5) + $(dbh_tooltipEcke).height()) + "px");
        $(tooltip).css('left', $(elem).position().left + "px");
    }

    public isMail = (myString): boolean => {
        return this.options.regexIsMail.test(myString);
    }

    public isNumber = (myString): boolean => {
        return this.options.regexIsNumber.test(myString);
    }

    public validate = (): boolean => {
        return this.validateInternal(null, this.errorList);
    };
}
